import React from "react";
import PropTypes from "prop-types";
import PromiseResolver from "./promise-resolver";
// set your parent should to position: relative unless you want a full screen loader

const PromiseResolverLoading = ({ render, children, LoadingComponent, ...props }) => {
  const cb = typeof render === "function" ? render : children;
  return (
    <PromiseResolver
      children={args =>
        args.loading ? (
          <div
            style={{
              textAlign: "center",
              position: "absolute",
              top: "50%",
              left: "50%",
            }}
          >
            {LoadingComponent}
          </div>
        ) : (
          cb(args)
        )
      }
      {...props}
    />
  );
};

PromiseResolverLoading.propTypes = {
  render: PropTypes.func,
  LoadingComponent: PropTypes.element,
};

PromiseResolverLoading.default = {
  render: () => null,
  LoadingComponent: <div>Loading...</div>,
};

export default PromiseResolverLoading;
